module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/welcome_to_tfl.2a41af7ffc1a60e2d5024bd718bf82f7.svg";